import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import { findDOMNode } from 'react-dom';
import { Popover, Input, Modal, Icon, Button, Checkbox, Radio, Transfer, Select } from 'antd';
import Row from './row';
import Col from './col';
import Input2 from './input';
import * as groupConditionRedux from '../../redux/groupCondition';
import InputSearch from '../common/InputSearch';
import SvgIcon from 'SvgIcon';
import EChartDesign from '../echart/echart/eChartDesign';
// import EChartPanelList from '../echart/panel/eChartPanelList';
import * as eChartCommon from '../echart/eChartCommon';
import * as eChartDemoData from '../echart/eChartDemoData';
import { genAction, proxy } from '../../helpers/util';
import Newformula from './newformula2';
import uuid from 'uuid';

const RadioGroup = Radio.Group;
class GroupCondition extends React.Component {
  constructor(props) {

    super(props);
    const { viewModel } = props;
    const { billNo } = viewModel.getParams();
    const { groupConditionState, groupConditionRedux } = this.props;
    let viewid = this.props.viewid ? this.props.viewid : "";
    let bPublished = viewid ? true : false;
    groupConditionRedux.initConditionListValue(billNo, { billnum: billNo, bShowList: false, bShowCard: false, viewid }, viewModel);
    this.state = {
      billnum: billNo,
      // bCancelSetting: false,
      bIgnoreAuth: false,
      viewid: viewid,
      bPublished: bPublished,
      name: viewModel.getParams().name ? viewModel.getParams().name : "",
      bUseZhiBiao: false,
      newAdd: false,
      editDefineItem: {}
    };

    this.groupSchemasMeta = {
      cControlType: 'Select',
      modelType: 'ListModel',
      cItemName: 'groupSchemas',
      valueField: 'id',
      textField: 'name',
    };
    viewModel.addProperty(this.groupSchemasMeta.cItemName, new cb.models[this.groupSchemasMeta.modelType](this.groupSchemasMeta));
    this.noGroupAndAuth = false;
    this.usedFields = [];
    this.definePrefix = "NewAdd_";
  }
  doProxy(url, method, params, callback, noUniform) {
    const config = { url: url, method: method, params: params };
    if (noUniform) {
      config.options = { uniform: false };
    }
    proxy(config)
      .then(json => {
        callback(json);
      });
  }
  getDimensionData() {
    let self = this;

    let callback = (json) => {
      if (json.code === 200) {
        if (json.data) {
          self.setState({ dimensionData: json.data });
        }
      }
    }
    self.doProxy('/report/getDimensions', 'GET', { billnum: this.state.billnum }, callback);
  }
  componentDidMount() {
    // this.getDimensionData();
  }
  componentWillUnmount() {
  }
  componentWillUpdate(nextProps, nextState) {
  }
  componentDidUpdate() {
  }

  // 监听外部props的变化, 如果变化了需要更新组件的state
  componentWillReceiveProps(nextProps) {
  }
  switchGroupSchema(id, name, dimensionId, newEle) {
    const { viewModel, groupConditionState, groupConditionRedux } = this.props;
    let currentId = groupConditionState[this.getBillNum()] && groupConditionState[this.getBillNum()].currentId;
    let conditionList = groupConditionState[this.getBillNum()] && groupConditionState[this.getBillNum()].conditionList;
    let currentEle = _.find(conditionList, function (o) { return o.id === currentId })
    let needReload = true;
    if (newEle && currentEle && cb.isInTouchReport(this.props.viewModel)) {
      let newDisplayStyle = newEle.displayStyle || 1;
      let currentDisplayStyle = currentEle.displayStyle || 1;
      if (newDisplayStyle != currentDisplayStyle) {
        needReload = false;
      }
    }
    /*系统参数  分组切换是否自动搜索*/
    const option = cb.rest.AppContext && cb.rest.AppContext.option || {};
    let tmp = [];
    if (id)
      tmp.push({ id, name });
    viewModel.get('groupSchemas').setDataSource(tmp);
    viewModel.get('groupSchemas').setValue(id);
    viewModel.biz.do("switchGroupSchema", viewModel, { groupSchemaId: id, groupSchemaName: name, dimensionId, needReload, switchgroupautorefresh: option.switchgroupautorefresh });
  }

  handleBodyClick = (e) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    // if (this.contains(this.refs.input_search, e.target)) return;
    if (e.target && cb.dom(e.target).parents('div.ant-popover').length) return;
    if (e.target.parentElement.className == "ant-input-group-addon") return;
    if (e.target.parentElement.className == "ant-popover-open") return;
    if (e.target.tagName == "CANVAS") return;
    if (e.target.parentElement.parentElement.className == "ant-popover-open") return;
    if (e.target.parentElement.className == "ant-input-wrapper ant-input-group") return;
    if (groupConditionState[this.getBillNum()].bShowCard == true) {
      if (groupConditionState[this.getBillNum()].editCondition.columnDefineInfo.bShowDefine == true) {
        this.showColumnDefine(false, {})
      }
      return;
    }
    document.body.removeEventListener('click', this.handleBodyClick);
    groupConditionRedux.setValue(this.getBillNum(), { bShowList: false });
    if (e.target && e.target.className)
      if (e.target.className.indexOf("anticon-upNONO") >= 0 || e.target.className.indexOf("anticon-down") >= 0) {
        e.preventDefault();
        e.stopPropagation();
      }
  }
  getUsedFields() {
    const { groupConditionState, groupConditionRedux } = this.props;
    let fields = [];
    let arr = _.get(groupConditionState[this.getBillNum()], "eChart.eChartConfig.subChartConfigArr");

    if (arr && arr.length > 0) {
      arr.forEach((ele) => {

        let orderField = _.get(ele, "yySetting.orderInfo.orderField");
        if (orderField && fields.indexOf(orderField) < 0)
          fields.push(orderField);

        let dimensionX = _.get(ele, "yySetting.dataField.dimensionX");
        if (dimensionX && dimensionX.length > 0) {
          dimensionX.forEach((item) => {
            if (item.codeField && fields.indexOf(item.codeField) < 0) {
              fields.push(item.codeField);
            }
            if (item.nameField && fields.indexOf(item.nameField) < 0) {
              fields.push(item.nameField);
            }
          });
        }
        let dimensionSub = _.get(ele, "yySetting.dataField.dimensionSub");
        if (dimensionSub && dimensionSub.length > 0) {
          dimensionSub.forEach((item) => {
            if (item.codeField && fields.indexOf(item.codeField) < 0) {
              fields.push(item.codeField);
            }
            if (item.nameField && fields.indexOf(item.nameField) < 0) {
              fields.push(item.nameField);
            }
          });
        }

        let measure = _.get(ele, "yySetting.dataField.measure");
        if (measure && measure.length > 0) {
          measure.forEach((item) => {
            if (item.valueField && fields.indexOf(item.valueField) < 0) {
              fields.push(item.valueField);
            }
          });
        }

      });
    }
    return fields;
  }
  render() {
    let self = this;
    this.usedFields = this.getUsedFields();
    const { groupConditionState, groupConditionRedux } = self.props;
    if (groupConditionState[this.getBillNum()] == undefined)
      return <div />;
    // let type = groupConditionState[this.getBillNum()].textMouseEnterId == 4 && groupConditionState[this.getBillNum()].currentName != "" ? "close" : (groupConditionState[self.getBillNum()].bShowList ? "up" : "down");

    // let button = <div>
    //   <Icon
    //     //onClick={() => self.ShowList()}
    //     onClick={type == "close" ? () => self.chooseCondition() : () => self.ShowList()}
    //     type={type}
    //     onMouseEnter={() => this.onTextMouseEnter(true, 4)}
    //     onMouseLeave={() => this.onTextMouseEnter(false, 4)}
    //   />
    // </div>;
    eChartCommon.LogChartInfo("设置界面 render ", JSON.stringify(groupConditionState[this.state.billnum].eChart), 900);

    let bNeedClose = (cb.isInTouchReport(self.props.viewModel) || groupConditionState[this.getBillNum()].textMouseEnterId == 4) && groupConditionState[this.getBillNum()].currentName != "" ? true : false;
    let type = groupConditionState[self.getBillNum()].bShowList ? "up" : "down";

    let button = <div>
      {bNeedClose ? <Icon
        onClick={() => self.chooseCondition()}
        type={"close-circle"}
        onMouseEnter={() => this.onTextMouseEnter(true, 4)}
        onMouseLeave={() => this.onTextMouseEnter(false, 4)}
      /> : null}
      <Icon
        onClick={() => self.ShowList()}
        type={type}
        onMouseEnter={() => this.onTextMouseEnter(true, 4)}
        onMouseLeave={() => this.onTextMouseEnter(false, 4)}
      />
    </div>;



    let conditionList = null;
    conditionList = this.getConditionListRender();
    let conditionPop = (

      <div>
        <div className="Grouping-condition-left">{groupConditionState[this.getBillNum()].cShowCaption}</div>
        <Popover
          placement="bottom"
          overlayStyle={{ width: cb.isInTouchReport(self.props.viewModel) ? "280px" : "236px" }}
          content={conditionList} trigger={"click"}
          visible={groupConditionState[this.getBillNum()].bShowList}>
          <div className="Grouping-condition">
            <div className="Grouping-condition-input">
              <span className="Grouping-condition-span"
                onMouseEnter={() => this.onTextMouseEnter(true, 4)}
                onMouseLeave={() => this.onTextMouseEnter(false, 4)}
                style={{ cursor: "pointer" }}
                onClick={() => this.ShowList()}
                overlayStyle={{ width: "100px" }}>
                {groupConditionState[this.getBillNum()].currentName}
              </span>
              {button}
            </div>
          </div>
        </Popover>
      </div>
    );
    let conditionCard = this.getConditionCardRender();
    let eChartSetting = this.eChartSetting_getRender();
    let style = {};
    if (this.state.bPublished) {
      style = { display: "none" };
    }
    let formulaRender = null;
    let editCondition = groupConditionState[this.getBillNum()].editCondition;

    if (this.state.newAdd) {
      formulaRender = <Newformula
        closeAdd={this.closeAdd}
        model={this.props.viewModel}
        billnum={this.state.billnum}
        fieldItems={_.filter(editCondition.dataSource_UnSelected, function (o) { return "'price','number','money'".indexOf(o.dataType) >= 0 })}
        editData={this.state.editDefineItem}
        handleSaveFormula={this.handleSaveFormula}
      />;
    }

    return <div className="groupCondition" style={style}  >
      {conditionPop}
      {conditionCard}
      {eChartSetting}
      {formulaRender}
    </div>;
  }

  ShowList = () => {
    if (this.noGroupAndAuth == true) {
      cb.utils.alert("没有任何分组信息。");
      return;
    }
    document.body.addEventListener('click', this.handleBodyClick);
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.showList(this.getBillNum(), !groupConditionState[this.getBillNum()].bShowList);
  }

  getConditionListRender() {
    let self = this;
    const { groupConditionState, groupConditionRedux } = this.props;
    let conditionList = groupConditionState[this.getBillNum()].conditionList;
    let currentId = groupConditionState[this.getBillNum()].currentId;
    let renderList = [];
    let bAuthAdd = groupConditionState[this.getBillNum()].bAuthAdd;
    let bAuthEdit = groupConditionState[this.getBillNum()].bAuthEdit;
    let bAuthDel = groupConditionState[this.getBillNum()].bAuthDel;
    if (self.state.bIgnoreAuth === true) {
      bAuthAdd = true;
      bAuthEdit = true;
      bAuthDel = true;
    }

    if (conditionList && conditionList.length > 0) {
      // if (conditionList.length == 1) {
      //   // conditionList[0].isDefault = true;
      //   currentId = conditionList[0].id;
      // }
      conditionList.forEach(function (element, index) {
        let item;
        let isChecked = element.id == currentId ? true : false;
        let itemChecked = isChecked ? <span className="groupCondition-Checked"><i className="anticon icon-xuanzhong1" checked={isChecked}></i>  </span > : <span className="groupCondition-Checked">  </span >;
        let isDefault = element.isDefault ? element.isDefault : false;
        let itemDefault = isDefault ? <span className="groupCondition-Default"> <span className="crossdefault-btn">默认</span>  </span> : <span className="groupCondition-Default">  </span>;
        let isMouseEnter = element.isMouseEnter ? element.isMouseEnter : false;
        let itemEnter = (isMouseEnter && cb.isInTouchReport(self.props.viewModel) == false) ?
          <span className={"groupCondition-MouseEnter" + (groupConditionState[this.getBillNum()].textMouseEnterId > 0 && groupConditionState[this.getBillNum()].textMouseEnterId <= 3 ? groupConditionState[this.getBillNum()].textMouseEnterId : "")}>
            {isDefault ? null : <span
              onMouseEnter={() => this.onTextMouseEnter(true, 1)}
              onMouseLeave={() => this.onTextMouseEnter(false, 1)}
              onClick={() => this.setDefaultCondition(element.id)}>设为默认</span>
            }
            <span
              onMouseEnter={() => this.onTextMouseEnter(true, 2)}
              onMouseLeave={() => this.onTextMouseEnter(false, 2)}
              onClick={() => this.editConditionInfo(element.id)}
              style={{ display: bAuthEdit == true ? "" : 'none' }}
            >设置</span>
            <span
              onMouseEnter={() => this.onTextMouseEnter(true, 3)}
              onMouseLeave={() => this.onTextMouseEnter(false, 3)}
              onClick={() => this.deleteCondition(element.id)}
              style={{ display: bAuthDel == true ? "" : 'none' }}
            >删除</span>

          </span> : <span className="groupCondition-MouseEnter"> </span  >;
        if (cb.isInTouchReport(self.props.viewModel)) {
          item = (
            <Row style={{ minHeight: "25px" }}
              onClick={() => this.chooseCondition(element.id, element.name, element.dimensionId, element)}
              onMouseEnter={(e) => this.onMouseEnter(true, e, element.id)}
              onMouseLeave={(e) => this.onMouseEnter(false, e, element.id)}>
              {itemChecked}
              <span style={{ cursor: "pointer" }}> {element.name ? element.name : element.id}  </span>
              {itemDefault}
              {itemEnter}
            </Row>
          )
        }
        else {
          item = (
            <Row style={{ minHeight: "25px" }}
              onMouseEnter={(e) => this.onMouseEnter(true, e, element.id)}
              onMouseLeave={(e) => this.onMouseEnter(false, e, element.id)}>
              {itemChecked}
              <span style={{ cursor: "pointer" }} onClick={() => this.chooseCondition(element.id, element.name, element.dimensionId, element)}> {element.name ? element.name : element.id}  </span>
              {itemDefault}
              {itemEnter}
            </Row>
          )
        }
        renderList.push(item);
      }, this);
    }
    if (renderList.length < 1 && (bAuthAdd == false || cb.isInTouchReport(self.props.viewModel)))
      this.noGroupAndAuth = true;
    else
      this.noGroupAndAuth = false;



    return (
      <div className={"group-add-grouping-count " + (bAuthAdd == false ? "group-add-grouping-count-noauth" : "")}>
        <div style={{ overflow: "auto", maxHeight: "258px", paddingBottom: "2px" }} >{renderList}</div>
        <div className="group-add-grouping">
          <div
            onClick={() => this.addConditionInfo()}
            style={{ display: (bAuthAdd == true && cb.isInTouchReport(self.props.viewModel) == false) ? "" : 'none' }}
          ><SvgIcon type="plus" />新增分组</div>
        </div>
      </div>
    );
    // return (
    //   <div className="group-add-grouping-count ">
    //     <div style={{ overflow: "auto", maxHeight: "258px", paddingBottom: "2px" }} >{renderList}</div>
    //     {groupConditionState[this.getBillNum()].bAuthAdd == true ? <div className="group-add-grouping">
    //       <div
    //         onClick={() => this.addConditionInfo()}
    //       ><SvgIcon type="plus" />新增分组</div>
    //     </div> : ""}
    //   </div>
    // );
  }

  addConditionInfo() {
    const { groupConditionRedux } = this.props;
    this.getDimensionData();
    groupConditionRedux.editConditionInfo(this.getBillNum(), "");
  }
  editConditionInfo(id) {
    const { groupConditionRedux } = this.props;
    this.getDimensionData();
    groupConditionRedux.editConditionInfo(this.getBillNum(), id);
  }

  setDefaultCondition(id) {
    const { groupConditionRedux, viewModel } = this.props;
    groupConditionRedux.setDefaultCondition(this.getBillNum(), id, viewModel);
  }
  getBillNum() {

    return this.state.billnum;
    // let reduxBillNum = this.state.billnum;
    // if (!!this.state.viewid)
    //   reduxBillNum = reduxBillNum + "_" + this.state.viewid;
    // return reduxBillNum;
  }

  deleteCondition(id) {
    const { viewModel, groupConditionRedux } = this.props;
    groupConditionRedux.deleteCondition(this.getBillNum(), id, viewModel);
  }
  chooseCondition(id, name, dimensionId, conditionEle) {

    const { groupConditionState, groupConditionRedux } = this.props;
    if (groupConditionState[this.getBillNum()].currentName || name) {
      this.switchGroupSchema(id ? id : null, name, dimensionId, conditionEle);
      groupConditionRedux.chooseCondition(this.getBillNum(), id);
    }
  }
  onMouseEnter(bEnter, e, id) {
    const { groupConditionRedux } = this.props;
    groupConditionRedux.conditiOnMouseEnter(this.getBillNum(), id, bEnter);
  }

  onTextMouseEnter(bEnter, id) {
    const { groupConditionRedux } = this.props;
    groupConditionRedux.conditiOnTextMouseEnter(this.getBillNum(), id, bEnter);
  }

  handleOk = (e) => {
    const { groupConditionState, groupConditionRedux } = this.props;

    let condition = groupConditionState[this.getBillNum()].editCondition;
    let eChart = groupConditionState[this.getBillNum()].eChart;

    if (condition.isCrossTable == false && eChart && (eChart.displayType == 2 || eChart.displayType == 3) && (_.isEmpty(eChart.eChartConfig) == true || _.isEmpty(eChart.eChartConfig.subChartConfigArr) == true)) {
      cb.utils.alert("请设置图形报表信息。");
    }
    else if (condition.name == undefined || condition.name.trim() == "") {
      cb.utils.alert("名称不可为空。");
    }
    else if (_.isNull(eChart.eChartConfig.subChartColNum) || eChart.eChartConfig.subChartColNum.toString().trim() == "") {
      cb.utils.alert("图表列数请输入1-3的整数。");
    }
    else if (isNaN(eChart.eChartConfig.subChartColNum) == true || Number(eChart.eChartConfig.subChartColNum) < 1 || Number(eChart.eChartConfig.subChartColNum) > 3) {
      cb.utils.alert("图表列数请输入1-3的整数。");
    }
    else if (condition.dataSource_Selected.length == 0) {
      cb.utils.alert("没有选择列信息。");
    }
    else if (condition.isPc == false && condition.isMobile == false && condition.isTouch == false) {
      cb.utils.alert("请选择适用于PC/移动/触屏。");
    }
    else {
      const { viewModel } = this.props;
      groupConditionRedux.saveCondition(this.getBillNum(), viewModel);
    }
  }
  handleCancel = (e) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.cancelEdit(this.getBillNum());
  }


  editCondition_SetValue = (fieldName, fieldValue) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.editCondition_SetValue(this.getBillNum(), fieldName, fieldValue);
  }

  editCondition_SetIsCrossTable = (fieldName, fieldValue) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.editCondition_SetIsCrossTable(this.getBillNum(), fieldName, fieldValue);
  }
  getConditionCardRender() {
    const { groupConditionState, groupConditionRedux } = this.props;
    let editCondition = groupConditionState[this.getBillNum()].editCondition;
    eChartCommon.LogChartInfo(" groupcondition getConditionCardRender  editCondition  ", JSON.stringify(editCondition), 900);
    let bEdit = editCondition.bEdit;
    let content;
    if (groupConditionState[this.getBillNum()].bShowCard == true) {
      let card;
      if (editCondition.isCrossTable)
        card = this.getCrossCardRender();
      else
        card = this.getGroupCardRender();

      content =
        <Modal className='crossGroupingModal'
          title={bEdit ? "编辑" : "新增"}
          onOk={(e) => this.handleOk(e)}
          onCancel={(e) => this.handleCancel(e)}
          visible={true}
        >
          {card}
        </Modal>;
    }
    return content;
  }
  handleScroll = (direction, e) => {
    console.log('direction:', direction);
    console.log('target:', e.target);
  }

  moveItems = (bToRight) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.editCondition_MoveItems(this.getBillNum(), bToRight);

  }

  selectItems = (groupType, selectedKey, bSelected, bSelectedItems) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.editCondition_SelectedKey(this.getBillNum(), groupType, selectedKey, bSelected, bSelectedItems);
  }
  // filterOption = (inputValue, option) => {
  //   return option.title.indexOf(inputValue) > -1;
  // }

  getGroupCardRender() {
    let self = this;
    const { groupConditionState, groupConditionRedux } = this.props;
    let bEdit = groupConditionState[this.getBillNum()].editCondition.bEdit;
    let editCondition = groupConditionState[this.getBillNum()].editCondition;
    let leftContentCheckBoxs = [];
    let rightContentCheckBoxs_0 = [];
    let rightContentCheckBoxs_3 = [];
    let leftDisabledKeys = [];
    let bToRightEnable = false;
    let bToLeftEnable = false;
    editCondition.dataSource_Selected.forEach(function (ele, index) {
      let button = self.getColumnDefine(editCondition.columnDefineInfo, ele);
      if (ele.groupType == 0) {
        let displayValue = 'none',displayAsc = 'none',displayDesc = 'none';
        if(ele.columnDefine != "{}" && ele.columnDefine){
          ele.columnDefine = typeof(ele.columnDefine)=="string"? JSON.parse(ele.columnDefine) : ele.columnDefine
          if(ele.columnDefine.orderby == 'asc' || ele.columnDefine.orderby == 'ASC'){
            displayAsc = 'block'
          }
          if(ele.columnDefine.orderby == 'desc' || ele.columnDefine.orderby == 'DESC'){
            displayDesc = 'block'
          }
        }
        if(!ele.columnDefine || ele.columnDefine == "{}"||!ele.columnDefine.orderby){
          displayValue = 'block'
        }
        rightContentCheckBoxs_0.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={ele.bSelected ? ele.bSelected : false}
              disabled={self.usedFields.indexOf(ele.fieldname) >= 0}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, true)}>
              {ele.caption}
            </Checkbox>
            <div onClick={()=>self.sortItem(ele,"asc")} style={{display: displayValue}}>排序</div>
            <div onClick={()=>self.sortItem(ele,"desc")} style={{display:displayAsc}}><SvgIcon type="shengxu"></SvgIcon></div>
            <div onClick={()=>self.sortItem(ele,"")} style={{display:displayDesc}}><SvgIcon type="jiangxu"></SvgIcon></div>
            {button}
          </Row>);
      }
      else if (ele.groupType == 3) {
        rightContentCheckBoxs_3.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={ele.bSelected ? ele.bSelected : false}
              disabled={self.usedFields.indexOf(ele.fieldname) >= 0}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, true)}>
              {ele.caption}
            </Checkbox>
            {button}
          </Row>);
      }
      leftDisabledKeys.push(ele.fieldname);
      if (ele.groupType == editCondition.focusedGroupType)//&& ele.bSelected
        bToLeftEnable = true;
    });

    editCondition.dataSource_UnSelected.forEach(function (ele, index) {
      if (ele.caption && ele.caption.indexOf(editCondition.keyWord) > -1) {
        let bDisabled = leftDisabledKeys.indexOf(ele.fieldname) > -1 ? true : false;
        let bChecked = bDisabled || ele.bSelected ? true : false;

        leftContentCheckBoxs.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={bChecked}
              disabled={bDisabled}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, false)}>
              {ele.caption}
            </Checkbox>
          </Row>);
        if (bDisabled == false)// && (ele.bSelected ? ele.bSelected : false) == false
          bToRightEnable = true;
      }
    });
    let RadioControl = [];
    RadioControl.push(<span className="crosstypeName"><i className="anticon anticon-star"></i>类型</span>);
    if (bEdit == false || !editCondition.isCrossTable) {
      RadioControl.push(<span className="crosstypeNameList"><Radio checked={!editCondition.isCrossTable} onChange={(e) => this.editCondition_SetIsCrossTable("isCrossTable", !e.target.checked)}></Radio></span>);
      RadioControl.push(<span style={{ cursor: "pointer" }} onClick={() => this.editCondition_SetIsCrossTable("isCrossTable", false)}>分组</span>);
    }
    if (bEdit == false || editCondition.isCrossTable) {
      RadioControl.push(<span className="crosstypeNameList"><Radio checked={editCondition.isCrossTable} onChange={(e) => this.editCondition_SetIsCrossTable("isCrossTable", e.target.checked)}></Radio></span>);
      RadioControl.push(<span style={{ cursor: "pointer" }} onClick={() => this.editCondition_SetIsCrossTable("isCrossTable", true)}>交叉</span>);
    }

    let eChart = groupConditionState[this.getBillNum()].eChart;
    let isCanShowInMobile = this.canShowInMobile();
    let chartTags = this.getChartTags();
    let dimensionOptions = new Array();
    this.state.dimensionData && this.state.dimensionData.length && this.state.dimensionData.forEach(function (item) {
      dimensionOptions.push(<Option value={item.id}>{item.name}</Option>);
    });
    return <div>
      <Row className="crosstype">
        {RadioControl}
      </Row>
      <Row colCount={12} className="crosstype">
        <Col span={1} className="crosstypeName crosstypeline"><i className="anticon anticon-star nametitlemarginstar"></i>名称</Col>
        <Col span={1} />
        <Col span={4} className="crosstypeNameList crossinput"><Input defaultValue={editCondition.name} onChange={(e) => this.editCondition_SetValue("name", e.target.value)} /> </Col>
        <Col span={1} />
        <Col span={5} className="crosscheckbox"><Checkbox checked={editCondition.isDefault} onChange={(e) => this.editCondition_SetValue("isDefault", e.target.checked)} >设为默认</Checkbox></Col>
      </Row>
      <Row className="crosstype">
        <span className="eChart-displayTitle"><i className="anticon anticon-star"></i>布局</span>
        <div className="eChart-global">
          <span className="eChart_DisplayType"><Radio checked={eChart.displayType == 3 ? true : false} onChange={(e) => this.eChartSetting_SetDisplayType(3)}></Radio></span>
          <span className="" style={{ cursor: "pointer" }} onClick={() => this.eChartSetting_SetDisplayType(3)} >图+表</span>
          <span className="eChart_DisplayType"><Radio checked={eChart.displayType == 2 ? true : false} onChange={(e) => this.eChartSetting_SetDisplayType(2)}></Radio></span>
          <span className="" style={{ cursor: "pointer" }} onClick={() => this.eChartSetting_SetDisplayType(2)} >图</span>
          <span className="eChart_DisplayType"><Radio checked={(eChart.displayType == 2 || eChart.displayType == 3) ? false : true} onChange={(e) => this.eChartSetting_SetDisplayType(1)}></Radio></span>
          <span className="" style={{ cursor: "pointer" }} onClick={() => this.eChartSetting_SetDisplayType(1)} >表</span>
          <span className="eChart_Setting"><Button disabled={(eChart.displayType == 2 || eChart.displayType == 3) ? false : true} onClick={() => this.showEChartSetting(true, "")}>增加图形报表</Button></span >
          {eChart.displayType > 1 ? <span className="Charts-columns">图表列数</span> : ""}
          {eChart.displayType > 1 ? <span className="Charts-columns-input">
            <Input
              placeholder="请输入"
              value={eChart.eChartConfig.subChartColNum}
              onChange={(e) => this.eChartSetting_SetSubChartColNum(e.target.value)}
            />
          </span> : ""}
          {eChart.displayType > 1 ? <span className="Charts-columns-input-hint">请输入<span>1-3</span>的整数</span> : ""}

        </div>
      </Row>
      {eChart.displayType > 1 ?
        <Row className="crosstype">
          <span className="crosstypeName crosstypeline"><i className="anticon anticon-star"></i>展示</span>
          {chartTags}
        </Row> : ""
      }
      <Row className="crosstype">
        <span className="eChart-ApplyAt"><i className="anticon anticon-star"></i>展现</span>
        <span className="eChart-ApplyAtPc" style={{ cursor: "pointer" }} ><Checkbox checked={editCondition.isPc} onChange={(e) => this.editCondition_SetValue("isPc", e.target.checked)} >PC端展现</Checkbox></span>
        <span className="eChart-ApplyAtMobile" style={{ cursor: "pointer" }} ><Checkbox disabled={!isCanShowInMobile} checked={editCondition.isMobile} onChange={(e) => this.editCondition_SetValue("isMobile", e.target.checked)} >移动端展现</Checkbox></span>
        <span className="eChart-ApplyAtTouch" style={{ cursor: "pointer" }} ><Checkbox disabled={false} checked={editCondition.isTouch} onChange={(e) => this.editCondition_SetValue("isTouch", e.target.checked)} >触屏端展现</Checkbox></span>
      </Row>
      {this.state.dimensionData && this.state.dimensionData.length > 0 ?
        <Row  >
          <span className="eChart-ApplyAt"><i className="anticon"></i>导航</span>
          <Select value={editCondition.dimensionId}
            onChange={(value) => this.editCondition_SetValue("dimensionId", value)}>
            {dimensionOptions}
          </Select>
        </Row>
        : ""}
      <Row colCount={12}>
        <Col span={5} className="crossadddata">
          <div>
            <Row className="crossaddnamemargin">添加数据项</Row>
            <div className="crossselectborder">
              <InputSearch placeholder="请输入关键字"
                value={editCondition.keyWord}
                onChange={(value) => this.editCondition_SetValue("keyWord", value)}
                /*onPressEnter={this.InputKeyWord}
                onSearch={this.InputKeyWord}*/
                onDelete={() => this.editCondition_SetValue("keyWord", "")}
              />
              <Row className="crossadddatalist">{leftContentCheckBoxs}</Row>
            </div>
          </div>
        </Col>
        <Col span={2} className="crossbtncount">
          <Button disabled={!bToRightEnable} onClick={() => this.moveItems(true)} className={bToRightEnable ? "icon-right-enabled" : "icon-right-disabled"}></Button>
          <Button disabled={!bToLeftEnable} onClick={() => this.moveItems(false)} className={bToLeftEnable ? "icon-left-enabled" : "icon-left-disabled"}></Button>
        </Col>
        <Col span={5} className="selecteddata">
          <div>
            <Row className="crossaddnamemargin">已选数据项</Row>
            <div className="groupCondition-SelectedItem">
              <div onClick={() => this.editCondition_SetValue("focusedGroupType", 0)} className="groupCondition-SelectedItem-Row2">
                <div className={"titlemore  titlemore-none" + (editCondition.focusedGroupType == 0 ? " groupCondition-SelectedItem-Selected" : "")}><span>维度</span></div>
                <div className="titlename-list3">{rightContentCheckBoxs_0}</div>
              </div>
              <div onClick={() => this.editCondition_SetValue("focusedGroupType", 3)} className="groupCondition-SelectedItem-Row2">
                <div className={"titlemore" + (editCondition.focusedGroupType == 3 ? " groupCondition-SelectedItem-Selected" : "")}>
                  <span>指标</span>
                  <div className="groupCondition-HideAllZeroRow" style={{ display: '' }}>
                    <Checkbox checked={!editCondition.isDisplayZero}
                      onChange={(e) => this.editCondition_SetValue("isDisplayZero", !e.target.checked)} >指标全为零不显示</Checkbox>

                  </div>
                  <Button onClick={() => this.addFormula()}>
                    <SvgIcon type="plus" />
                      新增
                  </Button>
                </div>
                <div className="titlename-list3">{rightContentCheckBoxs_3}</div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>;
  }



  getChartTags() {
    let self = this;
    const { groupConditionState } = this.props;
    let eChart = groupConditionState[this.getBillNum()].eChart;
    let subChartConfigArr = _.get(eChart, "eChartConfig.subChartConfigArr");
    let bShowEChartSetting = groupConditionState[this.getBillNum()].bShowEChartSetting;
    let bShowEChartSetting_Add = groupConditionState[this.getBillNum()].bShowEChartSetting_Add;
    let tags = [];
    if (subChartConfigArr) {
      subChartConfigArr.forEach(function (ele, index) {
        let bAddAndLastOne = (index == subChartConfigArr.length - 1 && bShowEChartSetting && bShowEChartSetting_Add);
        if (bAddAndLastOne == false) {
          let textPath = "eChartSetting.title.text";
          if (_.get(ele, "yySetting.type") == "ranktable") {
            textPath = "yySetting.title.text";
          }
          let name = _.get(ele, textPath) || "图形";
          tags.push(<div className="eChart-SubChartTag" >
            <span className="eChart-SubChartTag-Name" onClick={() => self.showEChartSetting(true, ele.chartKey)}>
              {name}
            </span>
            <span className="eChart-SubChartTag-Icon" >
              <Icon
                onClick={() => self.removeConfig(ele.chartKey)}
                type={"guanbi1"}
              />
            </span>
          </div>);
        }
      });
    }
    return <div className="eChart-global2">
      {tags}
    </div>;
  }

  canShowInMobile() {
    const { groupConditionState } = this.props;
    let isCanShowInMobile = true;
    let subChartConfigArr = _.get(groupConditionState[this.getBillNum()], 'eChart.eChartConfig.subChartConfigArr');
    if (subChartConfigArr) {
      if (_.findIndex(subChartConfigArr, function (o) { return o.yySetting.type == "ranktable" }) >= 0) {
        isCanShowInMobile = false;
      }
    }
    return isCanShowInMobile;
  }

  eChartSetting_SetSubChartColNum = (fieldValue) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    if (fieldValue != "" && (isNaN(fieldValue) == true || Number(fieldValue) < 1 || Number(fieldValue) > 3)) {
      groupConditionRedux.eChartSetting_ReturnNothing();
      return;
    }
    else {
      if (fieldValue.indexOf(".") >= 0) {
        fieldValue = fieldValue.substring(0, fieldValue.indexOf("."))
      }
      groupConditionRedux.eChartSetting_SetSubChartColNum(this.getBillNum(), fieldValue);
    }
  }
  eChartSetting_SetDisplayType = (value) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.eChartSetting_SetDisplayType(this.getBillNum(), value);
  }


  removeConfig = (chartKey) => {
    // bShow 是否显示  true false
    // chartKey 为空则为新增，不为空则为编辑
    const { groupConditionState, groupConditionRedux } = this.props;
    // this.state.bCancelSetting = false;
    groupConditionRedux.eChartSetting_RemoveConfig(this.getBillNum(), chartKey);
  }

  showEChartSetting = (bShow, chartKey) => {
    // bShow 是否显示  true false
    // chartKey 为空则为新增，不为空则为编辑
    const { groupConditionState, groupConditionRedux } = this.props;
    // this.state.bCancelSetting = false;
    if (bShow) {
      if (!!chartKey) {
        let config = eChartCommon.subConfig_Get(groupConditionState[this.getBillNum()].eChart, chartKey);
        this.chart_Backup = config;
        this.chartKey_Backup = chartKey;
      }
      else {
        this.chart_Backup = undefined;
        this.chartKey_Backup = "";
      }
      groupConditionRedux.eChartSetting_Show(this.getBillNum(), bShow, chartKey);
    }
    else {
      groupConditionRedux.eChartSetting_CancelChartConfig(this.getBillNum(), this.chart_Backup, this.chartKey_Backup, !this.chartKey_Backup);
    }

  }



  eChartSetting_getRender = () => {
    const { groupConditionState, groupConditionRedux } = this.props;
    let content = null;

    if (groupConditionState[this.getBillNum()].bShowEChartSetting == true) {
      content = <Modal
        className="eChartSetting_Modal"
        title="设置图形报表"
        visible={true}
        footer={null}
        onCancel={() => this.showEChartSetting(false, "")}
      >
        <div className="eChartSetting_Control">
          <EChartDesign
            billnum={this.getBillNum()}
            chartKey={groupConditionState[this.getBillNum()].showEChartKey}
            reportFields={groupConditionState[this.getBillNum()].editCondition.dataSource_Selected}
          // bCancelSetting={this.state.bCancelSetting}
          />
        </div>
      </Modal>;
    }
    return content;
  }
  // cancelSetting() {
  //   this.setState({ bCancelSetting: true });
  // }
  setColumnDefineValue(groupType, fieldname, defineName, value) {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.setColumnDefineValue(this.getBillNum(), groupType, fieldname, defineName, value);
  }

  /*getColumnDefineRender(itemEle, defineData) {
    // "data": [
    //         {
    //             "controltype": "select",
    //             "name": "function",
    //             "caption": "函数",
    //             "enumArray": "[{\"value\":\"日期\",\"key\":\"fn_formatdateyyyymmdd\"},{\"value\":\"年\",\"key\":\"year\"},{\"value\":\"月\",\"key\":\"month\"}]",
    //             "value": "fn_formatdateyyyymmdd"
    //         },
    //     ]
    const {groupConditionState, groupConditionRedux } = this.props;
    let self = this;
    let renderList = [];
    if (defineData && defineData.length > 0) {
          defineData.forEach(function (ele, index) {
            let item;
            if (ele.controltype == "select") {
              let options = new Array();
              if (ele.enumArray && ele.enumArray.length) {
                let arr = JSON.parse(ele.enumArray);
                arr.forEach(function (ele2) {
                  options.push(<Option value={ele2.key}>{ele2.value}</Option>);
                });
              }
              item =
                <div>
                  <span>{ele.caption} </span>
                  <Select value={ele.value}
                    notFoundContent="无法找到"
                    onChange={e => this.setColumnDefineValue(itemEle.groupType, itemEle.fieldname, ele.name, e)}>
                    {options}
                  </Select>
                </div>;

            }
            else if (ele.controltype == "checkbox") {
              item = <Checkbox
                checked={ele.value == "true" ? true : false}
                onChange={(e) => self.setColumnDefineValue(itemEle.groupType, itemEle.fieldname, ele.name, e.target.checked.toString())}>
                {ele.caption}
              </Checkbox>;
            }
            if (item)
              renderList.push(<div  >{item}</div>);
          }, this);
        }

    return (
      <div className="group-add-grouping-count">
          <div  >{renderList}</div>
          <div >
            <Button type={"primary"} onClick={() => self.SaveColumnDefine(true)}>保存</Button>
            <Button type={"default"} onClick={() => self.SaveColumnDefine(false)}>取消</Button>
          </div>
        </div>
        );
  }*/



  getColumnDefineRender(itemEle, defineData) {
    // "data": [
    //         {
    //             "controltype": "select",
    //             "name": "function",
    //             "caption": "函数",
    //             "enumArray": "[{\"value\":\"日期\",\"key\":\"fn_formatdateyyyymmdd\"},{\"value\":\"年\",\"key\":\"year\"},{\"value\":\"月\",\"key\":\"month\"}]",
    //             "value": "fn_formatdateyyyymmdd"
    //         },
    //     ]
    {/*<RadioGroup onChange={this.onChange} value={this.state.value}>
        <Radio value={1}>A</Radio>
        <Radio value={2}>B</Radio>
        <Radio value={3}>C</Radio>
        <Radio value={4}>D</Radio>
      </RadioGroup>*/}
    const { groupConditionState, groupConditionRedux } = this.props;
    let self = this;
    let renderList = [];
    if (defineData && defineData.length > 0) {
      defineData.forEach(function (ele, index) {
        let item;
        if (ele.controltype == "select") {
          let options = new Array();
          if (ele.enumArray && ele.enumArray.length) {
            let arr = JSON.parse(ele.enumArray);
            arr.forEach(function (ele2) {
              options.push(<Radio value={ele2.key}>{ele2.value}</Radio>);
            });
          }
          item =
            <div>
              <span>{ele.caption} </span>
              <RadioGroup
                value={ele.value}
                onChange={e => this.setColumnDefineValue(itemEle.groupType, itemEle.fieldname, ele.name, e.target.value)}>
                {options}
              </RadioGroup>
            </div>;

        }
        else if (ele.controltype == "checkbox") {
          item = <Checkbox
            checked={ele.value == "true" ? true : false}
            onChange={(e) => self.setColumnDefineValue(itemEle.groupType, itemEle.fieldname, ele.name, e.target.checked.toString())}>
            {ele.caption}
          </Checkbox>;
        }
        if (item)
          renderList.push(<div  >{item}</div>);
      }, this);
    }

    return (
      <div className="group-add-grouping-count">
        <div  >{renderList}</div>
        <div className="footer-btn">
          <Button type={"primary"} onClick={() => self.SaveColumnDefine(true)}>保存</Button>
          <Button type={"default"} onClick={() => self.SaveColumnDefine(false)}>取消</Button>
        </div>
      </div>
    );
  }


  SaveColumnDefine(bSave) {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.editCondition_SaveColumnDefine(this.getBillNum(), bSave);
  }
  getColumnDefine(columnDefineInfo, itemEle) {
    let showIt = columnDefineInfo.bShowDefine
      && (columnDefineInfo.itemEle ? columnDefineInfo.itemEle.groupType : -1) == itemEle.groupType
      && (columnDefineInfo.itemEle ? columnDefineInfo.itemEle.fieldname : "") == itemEle.fieldname;
    let columnDefine = itemEle.columnDefine && JSON.parse(itemEle.columnDefine);
    if (columnDefine && columnDefine.bDefine == true) {
      return <div className='new-add-setbtn' onClick={(e) => this.editFormula(itemEle)} >设置</div>
    }
    else if (itemEle.canSet || itemEle.groupType == 1) {
      let columnDefineRender = undefined;
      // if (showIt) {
      columnDefineRender = this.getColumnDefineRender(itemEle, columnDefineInfo.defineData);
      // }
      let conditionPop = (
        <Popover
          overlayClassName="groupCondition-ColumnDefine"
          content={columnDefineRender}
          trigger={"click"}
          visible={showIt}>
          <div className="groupCondition-ColumnDefine-Design">
            <span
              style={{ cursor: "pointer" }}
              onClick={() => this.showColumnDefine(!columnDefineInfo.bShowDefine, itemEle)}
            >
              设置
          </span>
          </div>
        </Popover>);
      let cMemo = itemEle.cColumnDefineMemo;
      if (cMemo == undefined && itemEle.settings && itemEle.settings.length > 0) {
        cMemo = _.join(itemEle.settings, '/');
      }
      let cColumnDefineMemo;
      if (_.isEmpty(cMemo) == false)
        cColumnDefineMemo = <div className="columnDeinfe_Memo-count"><span>(</span> <span className="columnDeinfe_Memo" title={cMemo}>{cMemo}</span> <span>)</span></div>;
      return <div>{cColumnDefineMemo} {conditionPop}</div>;
    }
    else {
      return undefined;
    }
  }
  showColumnDefine(bShowDefine, itemEle) {
    const { groupConditionState, groupConditionRedux } = this.props;
    groupConditionRedux.editCondition_ShowColumnDefine(this.getBillNum(), bShowDefine, itemEle);
  }
  sortItem(ele,orderby){
    const {groupConditionRedux,groupConditionState} = this.props;
    let dataSource_Selected = groupConditionState[this.getBillNum()].editCondition.dataSource_Selected;
      let index = _.findIndex(dataSource_Selected,function(v){ return v.fieldname == ele.fieldname});
      let columnDefineConcat = {}
      if(index >= 0){
        let columnDefine = {
          orderby:orderby
        }
        if(dataSource_Selected[index].columnDefine && typeof(dataSource_Selected[index].columnDefine) !="string"){
          dataSource_Selected[index].columnDefine = Object.assign(dataSource_Selected[index].columnDefine,columnDefine)
        }
        else{
          dataSource_Selected[index].columnDefine = columnDefine
        }
        dataSource_Selected.forEach((ele)=>{
          if(ele.columnDefine && typeof(ele.columnDefine) != "string"){
            ele.columnDefine = JSON.stringify(ele.columnDefine)
          }
        })
      }
    groupConditionRedux.sortItem(this.getBillNum(),dataSource_Selected)
  }
  getCrossCardRender() {
    let self = this;
    const { groupConditionState, groupConditionRedux } = this.props;
    let bEdit = groupConditionState[this.getBillNum()].editCondition.bEdit;
    let editCondition = groupConditionState[this.getBillNum()].editCondition;
    let leftContentCheckBoxs = [];
    let rightContentCheckBoxs_0 = [];
    let rightContentCheckBoxs_1 = [];
    let rightContentCheckBoxs_2 = [];
    let rightContentCheckBoxs_3 = [];
    let leftDisabledKeys = [];
    let bToRightEnable = false;
    let bToLeftEnable = false;

    // groupType 值
    // 分组  0 分组项  3  统计项
    // 交叉  0 行标题  1 列标题  2 交叉点
    editCondition.dataSource_Selected.forEach(function (ele, index) {
      let button = self.getColumnDefine(editCondition.columnDefineInfo, ele);
      if (ele.groupType == 0) {
        let displayValue = 'none',displayAsc = 'none',displayDesc = 'none';
        if(ele.columnDefine != "{}" && ele.columnDefine){
          ele.columnDefine = typeof(ele.columnDefine)=="string"? JSON.parse(ele.columnDefine) : ele.columnDefine
          if(ele.columnDefine.orderby == 'asc' || ele.columnDefine.orderby == 'ASC'){
            displayAsc = 'block'
          }
          if(ele.columnDefine.orderby == 'desc' || ele.columnDefine.orderby == 'DESC'){
            displayDesc = 'block'
          }
        }
        if(!ele.columnDefine || ele.columnDefine == "{}"||!ele.columnDefine.orderby){
          displayValue = 'block'
        }
        rightContentCheckBoxs_0.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={ele.bSelected ? ele.bSelected : false}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, true)}>
              {ele.caption}
            </Checkbox>
            <div onClick={()=>self.sortItem(ele,"asc")} style={{display: displayValue}}>排序</div>
            <div onClick={()=>self.sortItem(ele,"desc")} style={{display:displayAsc}}><SvgIcon type="shengxu"></SvgIcon></div>
            <div onClick={()=>self.sortItem(ele,"")} style={{display:displayDesc}}><SvgIcon type="jiangxu"></SvgIcon></div>
            {button}
          </Row>);
        if (editCondition.focusedGroupType == 0 || editCondition.focusedGroupType == 2)
          leftDisabledKeys.push(ele.fieldname);
      }
      if (ele.groupType == 1) {
        rightContentCheckBoxs_1.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={ele.bSelected ? ele.bSelected : false}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, true)}>
              {ele.caption}
            </Checkbox>
            {button}
          </Row>);
        if (editCondition.focusedGroupType == 1 || editCondition.focusedGroupType == 2)
          leftDisabledKeys.push(ele.fieldname);
      }
      if (ele.groupType == 2) {
        rightContentCheckBoxs_2.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={ele.bSelected ? ele.bSelected : false}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, true)}>
              {ele.caption}
            </Checkbox>
            {button}
          </Row>);
        leftDisabledKeys.push(ele.fieldname);
      }
      if (ele.groupType == 3) {
        rightContentCheckBoxs_3.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={ele.bSelected ? ele.bSelected : false}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, true)}>
              {ele.caption}
            </Checkbox>
            {button}
          </Row>);
        leftDisabledKeys.push(ele.fieldname);
      }
      if (ele.groupType == editCondition.focusedGroupType)//&& ele.bSelected
        bToLeftEnable = true;
    });

    editCondition.dataSource_UnSelected.forEach(function (ele, index) {
      if (ele.caption && ele.caption.indexOf(editCondition.keyWord) > -1) {
        let bDisabled = leftDisabledKeys.indexOf(ele.fieldname) > -1 ? true : false;
        let bChecked = bDisabled || ele.bSelected ? true : false;

        leftContentCheckBoxs.push(
          <Row title={ele.tooltip || ele.caption} >
            <Checkbox
              checked={bChecked}
              disabled={bDisabled}
              onChange={(e) => self.selectItems(ele.groupType, ele.fieldname, e.target.checked, false)}>
              {ele.caption}
            </Checkbox>
          </Row>);
        if (bDisabled == false)//&& (ele.bSelected ? ele.bSelected : false) == false
          bToRightEnable = true;
      }
    });

    let RadioControl = [];
    RadioControl.push(<span className="crosstypeName"><i className="anticon anticon-star"></i> 类型</span>);
    if (bEdit == false || !editCondition.isCrossTable) {
      RadioControl.push(<span className="crosstypeNameList"><Radio checked={!editCondition.isCrossTable} onChange={(e) => this.editCondition_SetIsCrossTable("isCrossTable", !e.target.checked)}></Radio></span>);
      RadioControl.push(<span style={{ cursor: "pointer" }} onClick={() => this.editCondition_SetIsCrossTable("isCrossTable", false)}>分组</span>);
    }
    if (bEdit == false || editCondition.isCrossTable) {
      RadioControl.push(<span className="crosstypeNameList"><Radio checked={editCondition.isCrossTable} onChange={(e) => this.editCondition_SetIsCrossTable("isCrossTable", e.target.checked)}></Radio></span>);
      RadioControl.push(<span style={{ cursor: "pointer" }} onClick={() => this.editCondition_SetIsCrossTable("isCrossTable", true)}>交叉</span>);
    }


    return <div>
      <Row className="crosstype">
        {RadioControl}
      </Row>
      <Row colCount={12} className="crosstype">
        <Col span={1} className="crosstypeName crosstypeline"><i className="anticon anticon-star nametitlemarginstar"></i> 名称</Col>
        <Col span={1} />
        <Col span={4} className="crosstypeNameList crossinput"><Input defaultValue={editCondition.name} onChange={(e) => this.editCondition_SetValue("name", e.target.value)} /> </Col>
        <Col span={1} />
        {/*<Col span={5} className="crosscheckbox">
          <Checkbox checked={editCondition.bDisplayCrossPoint}
            onChange={(e) => this.editCondition_SetValue("bDisplayCrossPoint", e.target.checked)} >显示交叉点横向汇总</Checkbox>
        </Col>*/}
      </Row>
      <Row colCount={12} className="crosstype">
        <span className="eChart-ApplyAt"><i className="anticon anticon-star"></i>展现</span>
        <span className="eChart-ApplyAtPc" style={{ cursor: "pointer" }} ><Checkbox checked={editCondition.isPc} onChange={(e) => this.editCondition_SetValue("isPc", e.target.checked)} >PC端展现</Checkbox></span>
        <span className="eChart-ApplyAtMobile" style={{ cursor: "pointer" }} ><Checkbox disabled={false} checked={editCondition.isMobile} onChange={(e) => this.editCondition_SetValue("isMobile", e.target.checked)} >移动端展现</Checkbox></span>
        <span className="eChart-ApplyAtTouch" style={{ cursor: "pointer" }} ><Checkbox disabled={false} checked={editCondition.isTouch} onChange={(e) => this.editCondition_SetValue("isTouch", e.target.checked)} >触屏端展现</Checkbox></span>

      </Row>

      <Row colCount={12}>
        <Col span={5} className="crossadddata">
          <div>
            <Row className="crossaddnamemargin">添加数据项</Row>
            <div className="crossselectborder crossselectborder2">
              <InputSearch placeholder="请输入关键字"
                value={editCondition.keyWord}
                onChange={(value) => this.editCondition_SetValue("keyWord", value)}
                /*onPressEnter={this.InputKeyWord}
                onSearch={this.InputKeyWord}*/
                onDelete={() => this.editCondition_SetValue("keyWord", "")}
              />
              <Row className="crossadddatalist">{leftContentCheckBoxs}</Row>
            </div>
          </div>
        </Col>
        <Col span={2} className="crossbtncount">
          <Button disabled={!bToRightEnable} onClick={() => this.moveItems(true)} className={bToRightEnable ? "icon-right-enabled" : "icon-right-disabled"}></Button>
          <Button disabled={!bToLeftEnable} onClick={() => this.moveItems(false)} className={bToLeftEnable ? "icon-left-enabled" : "icon-left-disabled"}></Button>
        </Col>
        <Col span={5} className="selecteddata">
          <div className="groupCondition-Selected">
            <Row className="crossaddnamemargin">已选数据项</Row>
            <div className="groupCondition-SelectedItem groupCondition-SelectedItem2">
              <div onClick={() => this.editCondition_SetValue("focusedGroupType", 0)} className={"groupCondition-SelectedItem-Row groupCondition-SelectedItemNum" + (this.state.bUseZhiBiao ? "_4" : "_3")}>
                <div className={"titlemore  titlemore-none" + (editCondition.focusedGroupType == 0 ? " groupCondition-SelectedItem-Selected" : "")}><span>行标题</span></div>
                <div className="titlename-list">{rightContentCheckBoxs_0}</div>
              </div>
              <div onClick={() => this.editCondition_SetValue("focusedGroupType", 1)} className={"groupCondition-SelectedItem-Row groupCondition-SelectedItemNum" + (this.state.bUseZhiBiao ? "_4" : "_3")}>
                <div className={"titlemore" + (editCondition.focusedGroupType == 1 ? " groupCondition-SelectedItem-Selected" : "")}><span>列标题</span></div>
                <div className="titlename-list">{rightContentCheckBoxs_1}</div>
              </div>

              <div onClick={() => this.editCondition_SetValue("focusedGroupType", 2)} className={"groupCondition-SelectedItem-Row groupCondition-SelectedItemNum" + (this.state.bUseZhiBiao ? "_4" : "_3")}>
                <div className={"titlemore" + (editCondition.focusedGroupType == 2 ? " groupCondition-SelectedItem-Selected" : "")}>
                  <span>交叉点</span>
                  <div className="groupCondition-HideAllZeroRow" style={{ display: 'none' }}>
                    <Checkbox checked={!editCondition.isDisplayZero}
                      onChange={(e) => this.editCondition_SetValue("isDisplayZero", !e.target.checked)} >指标全为零不显示</Checkbox>
                  </div>
                </div>
                <div className="titlename-list">{rightContentCheckBoxs_2}</div>
              </div>
              <div style={{ display: "" }} className={"groupCondition-SelectedItem-zhibiao groupCondition-SelectedItemNum" + (this.state.bUseZhiBiao ? "_4" : "_3")}>
                <div
                  onClick={() => this.zhiBiaoClicked()} className={"titlemore" + (editCondition.focusedGroupType == 3 ? " groupCondition-SelectedItem-Selected" : "")}>
                  <span>指标</span>
                  <Button onClick={() => this.addFormula()}><SvgIcon type="plus" />新增</Button>
                  <Icon type={this.state.bUseZhiBiao ? "up" : "down"} />
                </div>
                <div onClick={() => this.editCondition_SetValue("focusedGroupType", 3)} className="titlename-list">{rightContentCheckBoxs_3}</div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>;

  }

  zhiBiaoClicked() {

    this.state.bUseZhiBiao = !this.state.bUseZhiBiao;
    if (this.state.bUseZhiBiao) {
      this.editCondition_SetValue("focusedGroupType", 3);
    }
    else {
      this.editCondition_SetValue("focusedGroupType", 0);
    }
  }
  addFormula = () => {
    this.setState({ newAdd: true, editDefineItem: {} });

  }
  editFormula = (ele) => {
    this.setState({ editDefineItem: ele, newAdd: true })
  }

  closeAdd = () => {
    this.setState({ newAdd: false })
  }

  handleSaveFormula = (ele) => {
    const { groupConditionState, groupConditionRedux } = this.props;
    let editCondition = groupConditionState[this.getBillNum()].editCondition;
    // groupConditionRedux.chooseCondition(this.getBillNum(), id);
    // operatorValue, filterName, numPoint
    let editDefineItem = this.state.editDefineItem;
    if (_.isEmpty(editDefineItem)) {
      editDefineItem = {
        fieldname: this.definePrefix + uuid(),
        groupType: 3,
        controlType: "InputNumber",
        dataType: "number"
      }
    }
    editDefineItem.caption = ele.filterName;
    let columnDefine = {
      expression: ele.expression,
      formulaData: ele.operatorValue,
      numPoint: ele.numPoint,
      bDefine: true,
    }
    editDefineItem.columnDefine = JSON.stringify(columnDefine)
    groupConditionRedux.saveDefineItem(this.getBillNum(), editDefineItem);
    this.setState({ newAdd: false })
  }
}

function mapStateToProps(state) {
  return {
    groupConditionState: state.groupCondition.toJS()
  }
}

function mapDispatchToProps(dispatch) {
  return {
    groupConditionRedux: bindActionCreators(groupConditionRedux, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupCondition);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/groupcondition.jsx